import {Component, Vue} from 'vue-property-decorator'
import {IPlatformInfo} from '@/entities'

@Component
class renderWithPlatformDataMixin extends Vue {

  get platform(): IPlatformInfo {
    return this.$storage.getters.getPlatformInfo();
  }

  get here(): string {
    return window.location.protocol + '//' + this.host;
  }

  get host(): string {
    return window.location.hostname;
  }

  protected renderWithData(label: string): string {
    return label
      .replace(/\{url\}/g, this.here)
      .replace(/\{host\}/g, this.host)
      .replace(/\{full_name\}/g, this.platform.full_name)
      .replace(/\{email\}/g, this.platform.email)
      .replace(/\{name\}/g, this.platform.name);
  }
}

export default renderWithPlatformDataMixin
